import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('profiles', 'confirm-phone-number', [
  'CLEAR',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'change_phone_number',
  ],
});

const requestReducer = createReqReducer(consts);

const clear = state => ({
  ...state,
  succeed: null,
  error: null,
});

export default (state, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR:
      return clear(state);

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/confirm-mobile-phone.js